// The backend serializes timestamps as naive UTC (no timezone offset), e.g.
// "2026-06-11T12:06:55.305164". `new Date(str)` would parse such a string as
// *local* time, so the value would render as the raw UTC wall-clock instead of
// being converted to the viewer's timezone. Appending 'Z' forces UTC parsing;
// date-fns `format` then renders it in the browser's local timezone.
export const parseUtcDate = (value: string | Date): Date => {
  if (value instanceof Date) return value;
  const hasTimezone = /([zZ])|([+-]\d{2}:?\d{2})$/.test(value);
  return new Date(hasTimezone ? value : `${value}Z`);
};
